// extracted by mini-css-extract-plugin
export var actions = "_q3-5";
export var assistantBubble = "_q3-3";
export var assistantRow = "_q3-6";
export var bubble = "_q3-0";
export var humanAvatar = "_q3-4";
export var inlineToolCard = "_q3-1";
export var userBubble = "_q3-2";